<template>
  <div class="HeatTreatmentParam">
    <template v-if="nowPage == '即時參數顯示'">
      <!-- <heatTreatmentInstant /> -->
    </template>
    <template v-else-if="nowPage == '歷史參數查詢'"
      ><heatTreatmentInquire
    /></template>
    <template v-else-if="nowPage == '統計分析'"
      ><heatTreatmentAnalysis
    /></template>
  </div>
</template>

<script>
// import heatTreatmentInstant from "@/components/heatTreatmentInstant.vue";
import heatTreatmentInquire from "@/components/heatTreatmentInquire.vue";
import heatTreatmentAnalysis from "@/components/heatTreatmentAnalysis.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HeatTreatmentParam",
  data() {
    return {
      nowPage: ""
    };
  },
  created: function() {
    window.addEventListener("beforeunload", this.setSessionItems);
    let page = sessionStorage.getItem("heat_treatment_param_page");
    if (page == "即時參數顯示") {
      this.set_sideBarSelect(["heattreatmentparam", "heattreatmentinstant"]);
    } else if (page == "歷史參數查詢") {
      this.set_sideBarSelect(["heattreatmentparam", "heattreatmentinquire"]);
    } else if (page == "統計分析") {
      this.set_sideBarSelect(["heattreatmentparam", "heatTreatmentAnalysis"]);
    }

    sessionStorage.removeItem("heat_treatment_param_page");
    this.change_selectPage("heattreatmentparam");
    this.change_selectPageName(this.pageName.heattreatmentparam);
  },
  mounted: function() {
    let vm = this;
    vm.nowPage = vm.sideBarSelect.processName;
    console.log(vm.nowPage);
  },
  components: {
    // heatTreatmentInstant,
    heatTreatmentInquire,
    heatTreatmentAnalysis
  },
  watch: {
    sideBarSelect: {
      handler() {
        let vm = this;
        vm.nowPage = vm.sideBarSelect.processName;
      }
    }
  },
  computed: {
    ...mapGetters({
      pageName: "getlogin/get_pageName",
      sideBarSelect: "sideBarTree/get_sideBarSelect"
    })
  },
  methods: {
    ...mapActions({
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect"
    }),
    setSessionItems() {
      sessionStorage.setItem(
        "heat_treatment_param_page",
        this.sideBarSelect.processName
      );
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
  }
};
</script>

<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/HeatTreatmentParam.vue